module.exports = __webpack_public_path__ + "static/img/menu_logo_white.3e49b7e.svg";